export const APP_STORE_URL =
  "https://apps.apple.com/ng/app/inawo-guest/id6768661916";
export const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.inawoo.inawoguest";
export const MOBILE_APP_PACKAGE = "com.inawoo.inawoguest";
export const BIRTHDAY_INVITATION_PATH = "/open/accept-team-invite";

export function birthdayInvitationToken(
  value: string | string[] | undefined
): string | null {
  return typeof value === "string" && value.length > 0 && value.trim() === value
    ? value
    : null;
}

export function birthdayInvitationAppUrl(token: string): string {
  return `inawoguest://open/accept-team-invite?token=${encodeURIComponent(
    token
  )}`;
}
